/* eslint-disable */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDashboard, clearElectionData } from "../store/slices/auth";
import ThemeSwitcher from '../components/ThemeSwitcher';
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import { API_BASE_URL } from "../utils/constants/api.constants";
import UploadRoster from "./UploadRoster";

export const bodyClass =
  "bg-slate-950 text-slate-100 h-screen min-h-0 flex flex-col overflow-hidden font-sans";


export default function AdminMarkup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    user,
    dashboard,
    dashboardLoading,
    dashboardError,
    clearElectionDataLoading,
  } = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(getDashboard());
  }, [dispatch]);
  const [uploadOpen, setUploadOpen] = useState(false);
  const handleRosterUpload = async ({
    type,
    csvText,
    headers,
    rows,
    replaceExisting,
    fileName,
  }) => {
    console.log("Import type:", type);
    console.log("CSV headers:", headers);
    console.log("CSV records:", rows);
    console.log("Replace existing:", replaceExisting);

    // Call the relevant page-specific API here.
    // Return false or throw an error if the API fails.

    return {
      success: true,
      message: `${rows.length} records processed successfully.`,
    };
  };

  const handleClearElectionData = async () => {
    const confirmed = window.confirm(
      "WARNING!\n\nThis will permanently delete all election data, including officers, subdivisions, circles, stations, booths and formations.\n\nAre you sure you want to continue?"
    );

    if (!confirmed) return;

    try {
      const result = await dispatch(clearElectionData()).unwrap();

      // Refresh dashboard after successful deletion
      await dispatch(getDashboard());

      window.alert(
        result?.message || "Election data cleared successfully."
      );
    } catch (error) {
      console.error("Clear election data failed:", error);

      window.alert(
        typeof error === "string"
          ? error
          : "Failed to clear election data. Please try again."
      );
    }
  };
  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      console.error("Admin socket: access token not found");
      return;
    }

    const socketUrl = new URL(API_BASE_URL).origin;

    const socket = io(socketUrl, {
      auth: { token },
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
    });

    window.adminSocket = socket;

    socket.on("connect", () => {
      console.log("ADMIN SOCKET CONNECTED:", socket.id);
    });

    socket.on("connect_error", (error) => {
      console.error("ADMIN SOCKET ERROR:", error.message);
    });

    socket.on("disconnect", (reason) => {
      console.log("ADMIN SOCKET DISCONNECTED:", reason);
    });

    socket.on("sos:created", (payload) => {
      console.log("🚨 BACKEND SOS RECEIVED:", payload);

      window.dispatchEvent(
        new CustomEvent("admin:sos-created", {
          detail: payload,
        })
      );
    });

    socket.on("sos:resolved", (payload) => {
      console.log("SOS RESOLVED:", payload);

      window.dispatchEvent(
        new CustomEvent("admin:sos-resolved", {
          detail: payload,
        })
      );
    });

    return () => {
      socket.removeAllListeners();
      socket.disconnect();

      if (window.adminSocket === socket) {
        delete window.adminSocket;
      }
    };
  }, []);

  useEffect(() => {
    console.log("DASHBOARD REDUX DATA:", dashboard);
  }, [dashboard]);

  const handleLogout = () => {
    // Clear authentication data
    localStorage.clear();
    sessionStorage.clear();

    // Redirect to login page
    window.location.replace("/login");
  };

  return (
    <div className="h-screen min-h-0 w-full flex flex-col overflow-hidden bg-slate-950 text-slate-100 font-sans">
      {/* TOP HEADER COMMAND BAR */}
      <header className="bg-slate-900 border-b border-slate-800 px-4 py-2 flex items-center justify-between shrink-0 shadow-md h-16 relative z-30">
        {/* 1. OFFICIAL IDENTITY & BRANDING */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-blue-700 via-indigo-600 to-blue-500 flex items-center justify-center text-white shadow-lg shadow-blue-900/50 text-xl font-black shrink-0 border border-blue-400/30">
            🇮🇳
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-sm font-black tracking-tight text-white flex items-center gap-2 uppercase">
                Nellore Police

              </h1>
            </div>

          </div>
        </div>
        {/* 2. ICONS-WISE PORTAL NAVIGATION BAR (Proper Website Style) */}
        <nav className="hidden lg:flex items-center bg-slate-950 p-1 rounded-xl border border-slate-800 text-xs font-semibold shadow-inner">
          <span className="px-3 py-1.5 bg-blue-600 text-white rounded-lg font-bold shadow flex items-center gap-1.5 cursor-default">
            <span>
              🗺️
            </span>
            <span>
              Live Map
            </span>
          </span>
          <a href="/emergency-sos" className="px-3 py-1.5 text-slate-300 hover:text-white hover:bg-slate-900 rounded-lg transition flex items-center gap-1.5">
            <span>
              🚨
            </span>
            <span>
              Incident Grid
            </span>
          </a>


        </nav>
        {/* 3. ACTIONS, TOOLS DROPDOWN LIST, THEME & USER PROFILE */}
        <div className="flex items-center gap-2">
          {/* Register Officer Primary Quick Action */}
          {/* Clear Election Data */}
          <button
            type="button"
            onClick={handleClearElectionData}
            disabled={clearElectionDataLoading}
            className={`px-3 py-1.5 text-white text-xs font-bold rounded-lg shadow flex items-center gap-1.5 transition ${clearElectionDataLoading
                ? "bg-red-900/50 cursor-not-allowed opacity-60"
                : "bg-red-700 hover:bg-red-600"
              }`}
          >
            <span>{clearElectionDataLoading ? "⏳" : "🗑️"}</span>
            <span>
              {clearElectionDataLoading ? "Clearing..." : "Clear Data"}
            </span>
          </button>

          {/* Upload Roster */}
          <button
            type="button"
            onClick={() => setUploadOpen(true)}
            className="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-bold rounded-lg shadow flex items-center gap-1.5 transition"
          >
            <span>📤</span>
            <span className="hidden sm:inline">Upload</span> Roster
          </button>


          {/* Operations & Tools Dropdown (Proper List-Wise View) */}
          <div className="relative inline-block text-left" id="header-tools-dropdown-container">


          </div>

          <ThemeSwitcher className="mr-0.5" labelClass="hidden 2xl:inline" />
          <div className="h-6 w-px bg-slate-800 mx-0.5"></div>
          {/* Authenticated Commander Profile & Logout */}
          <div className="flex items-center gap-2 pl-1">
            <div id="header-commander-insignia" className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-black shadow border border-yellow-400/40 shrink-0" style={{ background: "#172554", color: "#fef08a" }}>
              🦁
            </div>
            <div className="hidden sm:block text-right">
              <div
                id="header-commander-name"
                className="text-xl font-black text-white leading-tight truncate max-w-[130px]"
              >
                {user?.displayName || user?.name || user?.username || "Admin"}
              </div>

              <div
                id="header-commander-scope"
                className="text-[12px] text-amber-300 font-bold leading-tight truncate max-w-[160px]"
              >
                👑 {"Superintendent of Police"}
              </div>
            </div>
            <button
              type="button"
              onClick={handleLogout}
              title="Logout"
              className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-red-900/40 text-slate-300 hover:text-red-300 border border-slate-700 flex items-center justify-center text-sm transition cursor-pointer"
            >
              🚪
            </button>
          </div>
        </div>
      </header>
      {/* TOP KPI METRIC STRIP (CLICK ANY CARD TO OPEN IN SEPARATE GRID VIEW) */}
      <div className="bg-slate-900/90 border-b border-slate-800/80 px-4 py-2 shrink-0 grid grid-cols-12 gap-2 text-xs">

        {/* Total Sub Divisions */}
        <div
          onClick={() => navigate("/sub-divisions")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-purple-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-purple-400 uppercase font-bold tracking-wider">
              Sub Divisions
            </div>
            <div className="text-base font-black text-purple-300">
              {dashboardLoading ? "..." : dashboard?.totalSubDivisions ?? 0}
            </div>
          </div>
          <span className="text-xl text-purple-400 opacity-50">🏢</span>
        </div>

        {/* Total Circles */}
        <div
          onClick={() => navigate("/circles")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-sky-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-sky-400 uppercase font-bold tracking-wider">
              Total Circles
            </div>
            <div className="text-base font-black text-sky-300">
              {dashboardLoading ? "..." : dashboard?.totalCircles ?? 0}
            </div>
          </div>
          <span className="text-xl text-sky-400 opacity-50">⭕</span>
        </div>

        {/* Total Police Stations */}
        <div
          onClick={() => navigate("/stations")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-teal-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-teal-400 uppercase font-bold tracking-wider">
              Police Stations
            </div>
            <div className="text-base font-black text-teal-300">
              {dashboardLoading ? "..." : dashboard?.totalStations ?? 0}
            </div>
          </div>
          <span className="text-xl text-teal-400 opacity-50">🚔</span>
        </div>
        <div onClick={() => navigate("/booths")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-blue-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-slate-400 uppercase font-bold tracking-wider">
              Total Booths
            </div>
            <div id="stat-total-booths" className="text-base font-black text-white">
              {dashboardLoading ? "..." : dashboard?.totalPollingStations ?? 0}
            </div>
          </div>
          <span className="text-xl opacity-40">
            🗳️
          </span>
        </div>
        <div onClick={() => navigate("/officers")} className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-indigo-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-indigo-400 uppercase font-bold tracking-wider">
              Total Men
            </div>
            <div id="stat-total-staff" className="text-base font-black text-indigo-300">
              {dashboardLoading ? "..." : dashboard?.totalOfficers ?? 0}
            </div>
          </div>
          <span className="text-xl text-indigo-400 opacity-50">
            👮
          </span>
        </div>

        <div onClick={() => navigate("/route-mobiles")} className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-indigo-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-indigo-400 uppercase font-bold tracking-wider">
              Route Mobiles
            </div>
            <div id="stat-total-staff" className="text-base font-black text-indigo-300">
              {dashboardLoading ? "..." : dashboard?.routeMobileCount ?? 0}
            </div>
          </div>
          <span className="text-xl text-indigo-400 opacity-50">
            👮
          </span>
        </div>

        <div onClick={() => navigate("/striking-forces")} className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-indigo-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-indigo-400 uppercase font-bold tracking-wider">
              Striking Force
            </div>
            <div id="stat-total-staff" className="text-base font-black text-indigo-300">
              {dashboardLoading ? "..." : dashboard?.strikingForceCount ?? 0}
            </div>
          </div>
          <span className="text-xl text-indigo-400 opacity-50">
            👮
          </span>
        </div>
        <div onClick={() => navigate("/booths")} className="cursor-pointer bg-rose-950/40 hover:bg-rose-900/40 rounded-lg p-2 border border-rose-600/40 hover:border-rose-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-rose-400 uppercase font-bold tracking-wider">
              Hyper Sensitive
            </div>
            <div id="stat-hyper-sensitive" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.hyperSensitiveBooths ?? 0}
            </div>
          </div>
          <span className="text-xl text-rose-400">
            🔥
          </span>
        </div>
        <div onClick={() => navigate("/booths")} className="cursor-pointer bg-amber-950/30 hover:bg-amber-900/40 rounded-lg p-2 border border-amber-600/40 hover:border-amber-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-amber-400 uppercase font-bold tracking-wider">
              Sensitive
            </div>
            <div id="stat-hyper-sensitive" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.hyperSensitiveBooths ?? 0}
            </div>
          </div>
          <span className="text-xl text-amber-400">
            ⚠️
          </span>
        </div>

        <div onClick={() => navigate("/officers")} title="View Verified On-Site Personnel in Grid View" className="cursor-pointer bg-emerald-950/20 hover:bg-emerald-900/30 rounded-lg p-2 border border-emerald-600/30 hover:border-emerald-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-emerald-400 uppercase font-bold tracking-wider">
              On-Site (≤75m)
            </div>
            <div id="stat-onsite" className="text-base font-black text-emerald-400">
              {dashboardLoading ? "..." : dashboard?.atPollingStation ?? 0}
            </div>
          </div>
          <span className="text-xl text-emerald-500 opacity-60">
            ✓
          </span>
        </div>
        <div id="card-kpi-absent" onClick={() => navigate("/officers")} className="cursor-pointer bg-rose-950/30 hover:bg-rose-900/40 rounded-lg p-2 border border-rose-500/50 hover:border-rose-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-rose-400 uppercase font-bold tracking-wider">
              Not Attended
            </div>
            <div id="stat-non-attended" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.absentAttendance ?? 0}
            </div>
          </div>
          <span className="text-xl text-rose-500">
            ✕
          </span>
        </div>
        <div id="card-kpi-sos" onClick={() => navigate("/emergency-sos")} title="Click to View Active Emergency SOS Distress Incidents Directly" className="cursor-pointer bg-red-950/30 hover:bg-red-900/50 rounded-lg p-2 border border-red-500/50 hover:border-red-400 transition flex items-center justify-between animate-sos-strobe">
          <div>
            <div className="text-[10px] text-red-400 uppercase font-bold tracking-wider">
              Emergency SOS
            </div>
            <div id="stat-sos" className="text-base font-black text-red-500">
              {dashboardLoading ? "..." : dashboard?.activeSOS ?? 0}
            </div>
          </div>
          <span className="text-xl text-red-500">
            🚨
          </span>
        </div>
      </div >
      {/* DUTY NON-ATTENDANCE ALERT STRIP (SHOWN DYNAMICALLY) */}
      <div id="non-attendance-alert-strip" className="hidden bg-rose-950 border-b border-rose-600 px-4 py-2 shrink-0 flex items-center justify-between text-xs text-rose-200" >
        <div className="flex items-center gap-2">
          <span className="text-base font-bold">
            ⚠
          </span>
          <span>
            <strong>
              ATTENDANCE ALERT:
            </strong>
            {' '}
            <span id="non-attendance-count">
              0
            </span>
            {' '}Police Personnel have{' '}
            <u>
              NOT attended their allotted duty
            </u>
            ! Assigned Sub-Inspectors have been alerted.
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={(event) => { openAdminEmergencySosModal('NON_ATTENDED') }} className="px-2.5 py-1 bg-rose-600 hover:bg-rose-500 text-white font-bold rounded text-xs transition shadow flex items-center gap-1">
            <span>
              📋
            </span>
            {' '}View Absent List & Details
          </button>
          <a href="/emergency-sos?category=NON_ATTENDED" className="px-2.5 py-1 bg-slate-900 border border-rose-400 hover:bg-slate-800 text-rose-200 font-bold rounded text-xs transition">
            Full Grid
          </a>
          <button onClick={(event) => { document.querySelector('[data-filter=NON_ATTENDED]').click() }} className="px-2.5 py-1 bg-slate-800 hover:bg-slate-700 text-white font-semibold rounded text-xs transition">
            Filter Absent (Map)
          </button>
        </div>
      </div >
      {/* MAIN SPLIT VIEW */}
      <div className="flex-1 min-h-0 min-w-0 flex overflow-hidden">
        {/* LEFT SIDEBAR: HIERARCHY TREE FILTERS & BOOTH CARDS */}
        <aside className="w-[410px] h-full min-h-0 bg-slate-900 border-r border-slate-800 flex flex-col shrink-0 z-10 shadow-xl overflow-hidden">
          {/* Filters Box */}
          < div className="p-3 border-b border-slate-800 space-y-2" >
            {/* ACTIVE COMMANDER AUTHORITY BADGE */}
            < div id="sidebar-jurisdiction-banner" className="p-2.5 rounded-xl bg-slate-950 border border-amber-500/40 text-xs shadow-inner" >
              <div className="flex items-center justify-between text-[10px] font-bold uppercase tracking-wider text-amber-400 mb-1">
                <span className="flex items-center gap-1">
                  <span>
                    🛡️
                  </span>
                  {' '}Active Command Scope:
                </span>
                <span id="sidebar-scope-badge" className="px-1.5 py-0.2 rounded font-black bg-amber-500/20 text-amber-300">
                  SP FULL DISTRICT
                </span>
              </div>
              <div id="sidebar-jurisdiction-name" className="font-black text-white text-xs leading-tight">
                District-Wide (All 1,520 Booths & Formations)
              </div>
              <div id="sidebar-handle-below" className="text-[10px] text-slate-300 mt-1 font-semibold flex items-center gap-1">
                <span>
                  👑
                </span>
                {' '}
                <span>
                  Admin: Handles All Below Staff
                </span>
              </div>
            </div >
            {/* Universal Live Person, Formation & Booth Search */}
            < div className="relative" >
              <input type="text" id="search-input" placeholder="Search any officer, badge, phone, booth, wing..." className="w-full bg-slate-950 border border-indigo-700/60 rounded-xl pl-9 pr-3 py-2 text-xs text-white placeholder-slate-400 focus:outline-none focus:border-indigo-400 shadow-inner" />
              <span className="absolute left-3 top-2.5 text-indigo-400 text-xs">
                🔍
              </span>
              {/* Universal Live Person & Formation Search Results Flyout Panel */}
              <div id="person-search-results-panel" className="hidden"></div>
            </div >
            {/* Filter Status Buttons */}
            < div className="grid grid-cols-5 gap-1 text-[10px] font-bold" >
              <button data-filter="ALL" className="filter-btn py-1 px-1 rounded text-center bg-blue-600 text-white transition">
                All
              </button>
              <button data-filter="ON_SITE" className="filter-btn py-1 px-1 rounded text-center bg-slate-800 text-emerald-400 hover:bg-slate-700 transition">
                On-Site
              </button>
              <button data-filter="AWAY" className="filter-btn py-1 px-1 rounded text-center bg-slate-800 text-amber-400 hover:bg-slate-700 transition">
                Away
              </button>
              <button data-filter="NON_ATTENDED" className="filter-btn py-1 px-1 rounded text-center bg-slate-800 text-rose-400 hover:bg-slate-700 transition">
                Absent
              </button>
              <button data-filter="SOS" className="filter-btn py-1 px-1 rounded text-center bg-slate-800 text-red-400 hover:bg-slate-700 transition">
                🚨 SOS
              </button>
            </div >
            {/* Sensitivity Classification Buttons */}
            < div className="space-y-1 pt-0.5" >
              <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider flex items-center justify-between">
                <span>
                  Station Sensitivity:
                </span>
                <span className="text-indigo-400 text-[9px] font-semibold">
                  Security Grade
                </span>
              </div>
              <div className="grid grid-cols-4 gap-1 text-[10px] font-bold">
                <button data-sens="ALL" className="sens-filter-btn py-1 px-1 rounded text-center bg-indigo-600 text-white transition">
                  All
                </button>
                <button data-sens="HYPER_SENSITIVE" className="sens-filter-btn py-1 px-1 rounded text-center bg-slate-800 text-rose-400 hover:bg-slate-700 transition">
                  🔥 Hyper
                </button>
                <button data-sens="SENSITIVE" className="sens-filter-btn py-1 px-1 rounded text-center bg-slate-800 text-amber-400 hover:bg-slate-700 transition">
                  ⚠️ Sens
                </button>
                <button data-sens="NORMAL" className="sens-filter-btn py-1 px-1 rounded text-center bg-slate-800 text-emerald-400 hover:bg-slate-700 transition">
                  🟢 Norm
                </button>
              </div>
            </div >
            {/* Special Duty Wing / Formation Filter */}
            < div className="space-y-1 pt-0.5" >
              <div className="flex items-center gap-1.5 text-[11px]">
                <label className="text-cyan-400 font-bold shrink-0 w-24">
                  Duty Wing:
                </label>
                <select id="filter-duty-wing" className="flex-1 bg-slate-950 border border-cyan-700/60 text-slate-200 text-xs rounded-lg px-2 py-1">
                  <option value="ALL">
                    All Wings & Formations (All Men)
                  </option>
                  <option value="POLLING_STATION">
                    🏛️ Polling Station Duty (Booths)
                  </option>
                  <option value="ROUTE_MOBILE">
                    🚓 Route Mobiles (Sector Patrol)
                  </option>
                  <option value="CHECK_POST">
                    🚧 Check Posts (Border/Arterial)
                  </option>
                  <option value="STRIKING_FORCE">
                    ⚡ Striking Force (QRT Riot Unit)
                  </option>
                  <option value="FLYING_SQUAD">
                    🦅 Flying Squads (FST Enforcement)
                  </option>
                  <option value="COORDINATION_TEAM">
                    🤝 Coordination Liaison Teams
                  </option>
                  <option value="SHADOW_PARTY">
                    🕵️ Shadow Party (Surveillance)
                  </option>
                  <option value="STRONG_ROOM">
                    🏛️🔐 Strong Room Guards (EVM Vault)
                  </option>
                  <option value="GAS_PARTY">
                    🦺💨 Gas Party (Anti-Riot Smoke)
                  </option>
                  <option value="DRONE_OPERATOR">
                    🛸 Drone Surveillance Operators
                  </option>
                  <option value="RESERVE_FORCE">
                    🛡️ Reserve Force (Standby Platoon)
                  </option>
                </select>
              </div>
            </div >
            {/* HIERARCHY LEVEL 1: SUB-DIVISION (DSP) */}
            < div className="space-y-1 pt-0.5" >
              <div className="flex items-center gap-1.5 text-[11px]">
                <label className="text-indigo-400 font-bold shrink-0 w-24">
                  Sub-Division:
                </label>
                <select id="filter-subdiv" className="flex-1 bg-slate-950 border border-indigo-700/60 text-slate-200 text-xs rounded-lg px-2 py-1">
                  {/* Injected dynamically */}
                </select>
              </div>
              {/* HIERARCHY LEVEL 2: CIRCLE (INSPECTOR) */}
              <div className="flex items-center gap-1.5 text-[11px]">
                <label className="text-blue-400 font-bold shrink-0 w-24">
                  Circle:
                </label>
                <select id="filter-circle" className="flex-1 bg-slate-950 border border-blue-700/60 text-slate-200 text-xs rounded-lg px-2 py-1">
                  {/* Injected dynamically */}
                </select>
              </div>
              {/* HIERARCHY LEVEL 3: POLICE STATION (SUB-INSPECTOR SHO) */}
              <div className="flex items-center gap-1.5 text-[11px]">
                <label className="text-emerald-400 font-bold shrink-0 w-24">
                  Police Station:
                </label>
                <select id="filter-police-station" className="flex-1 bg-slate-950 border border-emerald-700/60 text-slate-200 text-xs rounded-lg px-2 py-1">
                  {/* Injected dynamically */}
                </select>
              </div>
            </div >
            <div className="flex justify-between items-center text-[10px] text-slate-400 pt-1 border-t border-slate-800">
              <span>
                Showing:{' '}
                <strong id="filtered-count" className="text-white">
                  --
                </strong>
              </span>
              <span className="text-slate-500">
                Tap card to focus on map
              </span>
            </div>
          </div >
          {/* SIDEBAR VIEW SWITCHER: [🏛️ Polling Booths] vs [👁️ Immediate Subordinates & Force Monitoring] */}
          < div className="px-3 pt-2 pb-1.5 bg-slate-900 border-b border-slate-800 space-y-1.5" >
            <div className="grid grid-cols-2 gap-1 bg-slate-950 p-1 rounded-xl border border-slate-800 text-[11px] font-bold">
              <button type="button" id="tab-sidebar-booths" onClick={(event) => { switchSidebarView('BOOTHS') }} className="py-1.5 px-2 rounded-lg transition flex items-center justify-center gap-1.5 bg-blue-600 text-white shadow">
                <span>
                  🏛️
                </span>
                <span>
                  Polling Booths
                </span>
              </button>
              <button type="button" id="tab-sidebar-subordinates" onClick={(event) => { switchSidebarView('SUBORDINATES') }} className="py-1.5 px-2 rounded-lg transition flex items-center justify-center gap-1.5 bg-slate-800 text-slate-300 hover:text-white">
                <span>
                  👁️
                </span>
                <span>
                  Force Monitoring
                </span>
              </button>
            </div>
            {/* ADMIN MASTER OVERSIGHT QUICK FILTER BAR (For Immediate Subordinates & Below Force) */}
            <div id="subordinates-oversight-bar" className="hidden pt-1 border-t border-slate-800/60 space-y-1">
              <div className="flex items-center justify-between text-[10px] font-bold">
                <span className="text-indigo-300 flex items-center gap-1">
                  <span>
                    🛡️
                  </span>
                  {' '}Subordinate Force Oversight:
                </span>
                <span id="subordinates-count-badge" className="px-1.5 py-0.2 rounded bg-indigo-500/20 text-indigo-300 font-mono text-[9px]">
                  --
                </span>
              </div>
              <div className="grid grid-cols-3 gap-1 text-[9px] font-bold">
                <button type="button" onClick={(event) => { filterSubordinatesByCategory('ALL') }} className="subord-filter-btn py-1 px-1 rounded bg-indigo-600 text-white text-center transition shadow" data-sub-cat="ALL">
                  All Force
                </button>
                <button type="button" onClick={(event) => { filterSubordinatesByCategory('ALLOTTED') }} className="subord-filter-btn py-1 px-1 rounded bg-slate-800 text-emerald-400 hover:bg-slate-700 text-center transition" data-sub-cat="ALLOTTED">
                  Allotted
                </button>
                <button type="button" onClick={(event) => { filterSubordinatesByCategory('RESERVE') }} className="subord-filter-btn py-1 px-1 rounded bg-slate-800 text-amber-400 hover:bg-slate-700 text-center transition" data-sub-cat="RESERVE">
                  Reserve Pool
                </button>
                <button type="button" onClick={(event) => { filterSubordinatesByCategory('MOVING') }} className="subord-filter-btn py-1 px-1 rounded bg-slate-800 text-cyan-400 hover:bg-slate-700 text-center transition" data-sub-cat="MOVING">
                  Live Moving
                </button>
                <button type="button" onClick={(event) => { filterSubordinatesByCategory('ABSENT') }} className="subord-filter-btn py-1 px-1 rounded bg-slate-800 text-rose-400 hover:bg-slate-700 text-center transition" data-sub-cat="ABSENT">
                  Absentees
                </button>
                <button type="button" onClick={(event) => { filterSubordinatesByCategory('SOS') }} className="subord-filter-btn py-1 px-1 rounded bg-slate-800 text-red-400 hover:bg-slate-700 text-center transition" data-sub-cat="SOS">
                  🚨 SOS Alert
                </button>
              </div>
            </div>
          </div >
          {/* Scrollable Booths List Container */}
          <div
            id="booths-list-container"
            className="flex-1 min-h-0 overflow-y-auto overscroll-y-contain p-3 space-y-2.5"
            style={{ minHeight: 0 }}
          >
            <div className="text-center p-6 text-slate-500 text-xs">
              Loading hierarchical polling booths...
            </div>
          </div >
          {/* Scrollable Immediate Subordinates & Force Monitoring Container */}
          <div
            id="subordinates-list-container"
            className="hidden flex-1 min-h-0 overflow-y-auto overscroll-y-contain p-3 space-y-2.5"
            style={{ minHeight: 0 }}
          >
            <div className="text-center p-6 text-slate-500 text-xs">
              Loading immediate subordinate force...
            </div>
          </div >
        </aside >
        {/* RIGHT: INTERACTIVE MAP */}
        <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-slate-950 overflow-hidden">

          {/* MAP FILTER BAR */}
          <div className="shrink-0 px-4 py-2 bg-slate-900 border-b border-slate-700 flex flex-wrap items-center gap-3">
            <div className="flex items-center gap-2">
              <span className="text-emerald-400 text-sm">🚔</span>
              <label
                htmlFor="map-filter-police-station"
                className="text-xs font-bold text-slate-300"
              >
                Police Station:
              </label>
            </div>

            <select
              id="map-filter-police-station"
              className="min-w-[220px] max-w-full bg-slate-950 border border-emerald-700/60 text-slate-200 text-xs rounded-lg px-3 py-2 focus:outline-none focus:border-emerald-400"
              defaultValue="ALL"
            >
              <option value="ALL">All Police Stations</option>
            </select>

            <span id="map-filter-result-count" className="text-[10px] text-slate-400">
              Showing all stations
            </span>
          </div>

          {/* MAP */}
          <div id="admin-map" className="flex-1 min-h-0 w-full"></div>

        </main>
      </div >

      <div id="history-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-4xl p-6 shadow-2xl text-slate-200 flex flex-col max-h-[92vh]">
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-3">
            <div className="flex items-center gap-2.5">
              <span className="text-2xl">
                🕒
              </span>
              <div>
                <h3 className="text-base font-bold text-white flex items-center gap-2">
                  24-Hour Location Breadcrumb Trail & Playback{' '}
                  <span className="text-[10px] bg-blue-500/20 text-blue-400 border border-blue-500/40 px-2 py-0.5 rounded font-mono font-bold">
                    STORED ONE DAY DATA
                  </span>
                </h3>
                <div id="history-person-name" className="text-xs text-indigo-300 font-bold mt-0.5">
                  Officer Name
                </div>
              </div>
            </div>
            <button onClick={(event) => { closeHistoryModal() }} className="text-slate-400 hover:text-white text-2xl font-bold">
              ×
            </button>
          </div>
          {/* History Map Container */}
          <div className="h-96 rounded-2xl overflow-hidden border border-slate-700 relative mb-4">
            <div id="history-map" className="w-full h-full"></div>
          </div>
          {/* Playback Timeline Scrubbing Controls */}
          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-3">
            <div className="flex items-center justify-between text-xs">
              <div className="flex items-center gap-4">
                <div>
                  <span className="text-[10px] text-slate-500 uppercase font-semibold block">
                    Time of Ping:
                  </span>
                  <strong id="history-time-display" className="text-blue-400 font-mono text-sm">
                    --:--
                  </strong>
                </div>
                <div>
                  <span className="text-[10px] text-slate-500 uppercase font-semibold block">
                    Speed:
                  </span>
                  <strong id="history-speed-display" className="text-white font-mono">
                    -- km/h
                  </strong>
                </div>
                <div>
                  <span className="text-[10px] text-slate-500 uppercase font-semibold block">
                    Duty Status:
                  </span>
                  <strong id="history-status-display" className="text-emerald-400">
                    AT_STATION
                  </strong>
                </div>
              </div>
              <div>
                <span className="text-[10px] text-slate-500 uppercase font-semibold block">
                  Coordinates:
                </span>
                <span id="history-coords-display" className="text-slate-300 font-mono text-xs">
                  --
                </span>
              </div>
            </div>
            {/* Timeline Slider */}
            <div>
              <input type="range" id="history-timeline-slider" min="0" max="24" defaultValue="0" className="w-full h-2 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-blue-500" />
              <div className="flex justify-between text-[10px] text-slate-500 font-mono mt-1">
                <span>
                  24 Hours Ago
                </span>
                <span>
                  12 Hours Ago
                </span>
                <span>
                  Current Real-time Position
                </span>
              </div>
            </div>
          </div>
          <div className="flex justify-end pt-3 border-t border-slate-800 mt-3">
            <button onClick={(event) => { closeHistoryModal() }} className="px-5 py-2 bg-slate-800 hover:bg-slate-700 rounded-xl text-xs font-bold text-slate-200">
              Close Trail View
            </button>
          </div>
        </div>
      </div>

      {/* ============================================== */}
      {/* ADD / MODIFY POLLING STATION & ALLOTTED OFFICER MODAL */}
      {/* ============================================== */}
      <div id="booth-modal" className="hidden fixed inset-0 z-[99999] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-lg p-6 shadow-2xl text-slate-200 flex flex-col max-h-[92vh]">
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-4">
            <h3 id="booth-modal-title" className="text-base font-bold text-white flex items-center gap-2">
              <span>
                ✏️
              </span>
              {' '}Modify Polling Station & Allotted Officer Data
            </h3>
            <button onClick={(event) => { closeBoothModal() }} className="text-slate-400 hover:text-white text-2xl font-bold">
              ×
            </button>
          </div>
          <form id="booth-form" onSubmit={(event) => { handleBoothFormSubmit(event) }} className="space-y-3.5 overflow-y-auto flex-1 pr-1">
            <input type="hidden" id="modal-booth-id" defaultValue="" />
            <input type="hidden" id="modal-officer-id" defaultValue="" />
            {/* Polling Station Details Group */}
            <div className="p-3 bg-slate-950/80 rounded-2xl border border-slate-800 space-y-2.5">
              <div className="text-xs font-bold text-indigo-400 uppercase tracking-wider">
                1. Polling Station Information
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                    Booth Code:
                  </label>
                  <input type="text" id="modal-booth-code" required placeholder="PS-0012" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono" />
                </div>
                <div>
                  <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                    Registered Voters:
                  </label>
                  <input type="number" id="modal-booth-voters" defaultValue="1050" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white" />
                </div>
              </div>
              <div>
                <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                  Station Building Name & Address:
                </label>
                <input type="text" id="modal-booth-name" required placeholder="Govt Model Higher Secondary School, Room 1" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                    Latitude (Decimal GPS):
                  </label>
                  <input type="number" step="any" id="modal-booth-lat" required placeholder="12.97160" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono" />
                </div>
                <div>
                  <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                    Longitude (Decimal GPS):
                  </label>
                  <input type="number" step="any" id="modal-booth-lng" required placeholder="77.59460" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono" />
                </div>
              </div>
              <div>
                <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                  Allotted Police Station (Sub-Inspector SHO):
                </label>
                <select id="modal-booth-ps" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white">
                  {/* Populated dynamically */}
                </select>
              </div>
              <div>
                <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                  Polling Station Sensitivity Classification:
                </label>
                <select id="modal-booth-sensitivity" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white">
                  <option value="NORMAL">
                    🟢 Normal Polling Station
                  </option>
                  <option value="SENSITIVE">
                    ⚠️ Sensitive (Vulnerable Area - Enhanced Guard)
                  </option>
                  <option value="HYPER_SENSITIVE">
                    🔥 Hyper Sensitive (Critical Area - Minimum 3 Armed Personnel)
                  </option>
                </select>
              </div>
            </div>
            {/* Allotted Police Officer Details Group */}
            <div className="p-3 bg-slate-950/80 rounded-2xl border border-slate-800 space-y-2.5">
              <div className="text-xs font-bold text-emerald-400 uppercase tracking-wider">
                2. Allotted Police Officer Data
              </div>
              <div>
                <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                  Assigned Election Security Wing / Formation:
                </label>
                <select id="modal-officer-duty-wing" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white">
                  <option value="POLLING_STATION">
                    🏛️ Polling Station Duty (Booths)
                  </option>
                  <option value="ROUTE_MOBILE">
                    🚓 Route Mobile (Sector Patrol)
                  </option>
                  <option value="CHECK_POST">
                    🚧 Check Post (Border/Arterial)
                  </option>
                  <option value="STRIKING_FORCE">
                    ⚡ Striking Force (QRT Riot Unit)
                  </option>
                  <option value="FLYING_SQUAD">
                    🦅 Flying Squad (FST Enforcement)
                  </option>
                  <option value="COORDINATION_TEAM">
                    🤝 Coordination Liaison Team
                  </option>
                  <option value="SHADOW_PARTY">
                    🕵️ Shadow Party (Surveillance)
                  </option>
                  <option value="STRONG_ROOM">
                    🏛️🔐 Strong Room Guard (EVM Vault)
                  </option>
                  <option value="GAS_PARTY">
                    🦺💨 Gas Party (Anti-Riot Smoke Platoon)
                  </option>
                  <option value="DRONE_OPERATOR">
                    🛸 Drone Surveillance Operator
                  </option>
                  <option value="RESERVE_FORCE">
                    🛡️ Reserve Force (Standby Platoon)
                  </option>
                </select>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                    Police Officer Name:
                  </label>
                  <input type="text" id="modal-officer-name" required placeholder="Rajesh Kumar" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white" />
                </div>
                <div>
                  <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                    Mobile Phone Number:
                  </label>
                  <input type="text" id="modal-officer-phone" required placeholder="+91 98765 00000" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                    Designation / Rank:
                  </label>
                  <select id="modal-officer-desig" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white">
                    <option value="Police Constable (PC)">
                      Police Constable (PC)
                    </option>
                    <option value="Head Constable (HC)">
                      Head Constable (HC)
                    </option>
                    <option value="Asst. Sub-Inspector (ASI)">
                      Asst. Sub-Inspector (ASI)
                    </option>
                    <option value="Sub-Inspector (SI)">
                      Sub-Inspector (SI)
                    </option>
                    <option value="Armed Reserve (AR)">
                      Armed Reserve (AR)
                    </option>
                  </select>
                </div>
                <div>
                  <label className="block text-[11px] font-semibold text-slate-300 mb-1">
                    Badge Number:
                  </label>
                  <input type="text" id="modal-officer-badge" required placeholder="PC-4091" className="w-full bg-slate-900 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono" />
                </div>
              </div>
            </div>
            {/* Form Buttons */}
            <div className="flex justify-end gap-2 pt-3 border-t border-slate-800">
              <button type="button" onClick={(event) => { closeBoothModal() }} className="px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-xl text-xs font-semibold text-slate-300">
                Cancel
              </button>
              <button type="submit" className="px-5 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-xl text-xs font-bold shadow-lg flex items-center gap-1.5">
                <span>
                  💾
                </span>
                {' '}Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* ============================================== */}
      {/* REGISTER OFFICER / USER CREATION MODAL */}
      {/* ============================================== */}
      <div id="register-officer-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-2xl p-6 shadow-2xl text-slate-200 flex flex-col max-h-[92vh]">
          {/* Modal Header */}
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-2xl bg-gradient-to-tr from-emerald-600 to-teal-500 flex items-center justify-center text-white shadow-lg text-xl font-black">
                ➕
              </div>
              <div>
                <h3 className="text-base font-bold text-white flex items-center gap-2">
                  <span>
                    Register New Police Officer / User
                  </span>
                  <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/30">
                    GENERAL NO & BOOTH
                  </span>
                </h3>
                <p className="text-xs text-slate-400">
                  Create an official individual user profile with General Number or Polling Booth Code for live monitoring & login
                </p>
              </div>
            </div>
            <button type="button" onClick={(event) => { closeRegisterOfficerModal() }} className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white flex items-center justify-center text-xl font-bold transition">
              ×
            </button>
          </div>
          <form onSubmit={(event) => { submitRegisterOfficer(event) }} className="space-y-3.5 overflow-y-auto flex-1 pr-1 text-xs">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Full Name of Officer / Personnel:
                </label>
                <input type="text" id="reg-officer-name" required placeholder="e.g. Anand Kumar Gowda" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white placeholder-slate-500 focus:outline-none focus:border-emerald-500 font-semibold" />
              </div>
              <div>
                <label className="block font-bold text-slate-200 mb-1 flex items-center justify-between">
                  <span>
                    General Number (Badge / Force No):
                  </span>
                  <button type="button" onClick={(event) => { generateAutoGeneralNo() }} className="text-[10px] text-emerald-400 hover:underline">
                    Auto-Gen
                  </button>
                </label>
                <input type="text" id="reg-officer-gen-no" required placeholder="GEN-8402 / PC-4050 / HG-102" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white placeholder-slate-500 focus:outline-none focus:border-emerald-500 font-mono font-bold" />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Cadre & Designation:
                </label>
                <select id="reg-officer-cadre" onChange={(event) => { handleRegCadreChange() }} className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white focus:outline-none focus:border-emerald-500 font-bold">
                  <option value="PC">
                    👮 Police Constable (PC)
                  </option>
                  <option value="HC">
                    🔻 Head Constable (HC)
                  </option>
                  <option value="ASI">
                    ⭐ Asst. Sub-Inspector (ASI)
                  </option>
                  <option value="SI">
                    🛡️ Sub-Inspector (SHO)
                  </option>
                  <option value="CI">
                    👮 Circle Inspector of Police (CI)
                  </option>
                  <option value="DSP">
                    🌟 Deputy Superintendent of Police (DSP)
                  </option>
                  <option value="HG">
                    💂 Home Guard (Auxiliary Force)
                  </option>
                  <option value="AR">
                    🛡️ Armed Reserve (State Police)
                  </option>
                  <option value="OTHER">
                    ⚔️ Central Armed Police (CAPF / BSF / CRPF)
                  </option>
                  <option value="WING">
                    ⚡ Tactical Formation Wing Officer
                  </option>
                </select>
              </div>
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Official Mobile / Contact Phone:
                </label>
                <input type="text" id="reg-officer-phone" required placeholder="+91 98450 12345" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono placeholder-slate-500 focus:outline-none focus:border-emerald-500" />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block font-bold text-slate-200 mb-1 flex items-center justify-between">
                  <span>
                    Allotted Polling Booth Code:
                  </span>
                  <span className="text-[10px] text-slate-400 font-normal">
                    Leave empty for reserve
                  </span>
                </label>
                <input type="text" id="reg-officer-booth-code" placeholder="e.g. PS-0001 (or blank for Standby)" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono placeholder-slate-500 focus:outline-none focus:border-emerald-500" />
              </div>
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Jurisdiction / Base Police Station:
                </label>
                <select id="reg-officer-station" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white focus:outline-none focus:border-emerald-500">
                  {/* Dynamically populated */}
                </select>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Duty Wing / Formation:
                </label>
                <select id="reg-officer-wing" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white focus:outline-none focus:border-emerald-500">
                  <option value="POLLING_STATION">
                    🏛️ Polling Station Sentry
                  </option>
                  <option value="ROUTE_MOBILE">
                    🚓 Route Mobile Patrol
                  </option>
                  <option value="CHECK_POST">
                    🚧 Border / Arterial Check Post
                  </option>
                  <option value="STRIKING_FORCE">
                    ⚡ Striking Force (QRT)
                  </option>
                  <option value="FLYING_SQUAD">
                    🦅 Flying Squad (FST)
                  </option>
                  <option value="STRONG_ROOM">
                    🏛️🔐 Strong Room EVM Guard
                  </option>
                  <option value="SHADOW_PARTY">
                    🕵️ Shadow Party Surveillance
                  </option>
                  <option value="GAS_PARTY">
                    🦺💨 Gas Party (Anti-Riot)
                  </option>
                  <option value="DRONE_OPERATOR">
                    🛸 Drone Surveillance Operator
                  </option>
                  <option value="COORDINATION_TEAM">
                    🤝 Coordination Liaison Team
                  </option>
                  <option value="RESERVE_FORCE">
                    🛡️ Standby Reserve Force
                  </option>
                </select>
              </div>
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Allocation Status:
                </label>
                <select id="reg-officer-allotted" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white focus:outline-none focus:border-emerald-500">
                  <option value="ALLOTTED">
                    ✅ Allotted Active Duty
                  </option>
                  <option value="STANDBY_RESERVE">
                    🛡️ Standby Reserve (Not Allotted)
                  </option>
                </select>
              </div>
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Individual Login PIN:
                </label>
                <input type="text" id="reg-officer-pin" defaultValue="1234" required className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono focus:outline-none focus:border-emerald-500" />
              </div>
            </div>
            <div className="p-3 bg-emerald-950/30 border border-emerald-600/30 rounded-xl text-[11px] text-emerald-200 flex items-start gap-2">
              <span className="text-base shrink-0">
                ℹ️
              </span>
              <span>
                Once registered, this officer can log in individually on the{' '}
                <strong>
                  Login Page
                </strong>
                {' '}using their{' '}
                <strong>
                  General Number
                </strong>
                {' '}(or Polling Booth Code) and PIN to report GPS location, receive orders from superior officers, and activate emergency SOS.
              </span>
            </div>
            <div className="flex justify-end gap-2 pt-2 border-t border-slate-800">
              <button type="button" onClick={(event) => { closeRegisterOfficerModal() }} className="px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-xl text-xs font-semibold text-slate-300">
                Cancel
              </button>
              <button type="submit" className="px-5 py-2 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white rounded-xl text-xs font-bold shadow-lg flex items-center gap-1.5">
                <span>
                  💾
                </span>
                {' '}Create Officer & Enable Login
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* ============================================== */}
      {/* DUTY CORRECTION & REASSIGNMENT MODAL */}
      {/* ============================================== */}
      <div id="duty-correction-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-xl p-6 shadow-2xl text-slate-200 flex flex-col max-h-[92vh]">
          {/* Modal Header */}
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-2xl bg-gradient-to-tr from-amber-600 to-yellow-500 flex items-center justify-center text-slate-950 shadow-lg text-xl font-black">
                ✏️
              </div>
              <div>
                <h3 className="text-base font-bold text-white flex items-center gap-2">
                  <span>
                    Duty Correction & Reassignment
                  </span>
                  <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-amber-500/20 text-amber-300 border border-amber-500/30">
                    ADMIN MASTER OVERSIGHT
                  </span>
                </h3>
                <p className="text-xs text-slate-400">
                  Directly correct, reassign polling booth or duty wing, and resolve non-attendance / absentees
                </p>
              </div>
            </div>
            <button type="button" onClick={(event) => { closeDutyCorrectionModal() }} className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white flex items-center justify-center text-xl font-bold transition">
              ×
            </button>
          </div>
          <form onSubmit={(event) => { submitDutyCorrection(event) }} className="space-y-3.5 overflow-y-auto flex-1 pr-1 text-xs">
            {/* Officer Selector / Summary */}
            <div>
              <label className="block font-bold text-slate-200 mb-1">
                Select Police Personnel to Correct / Reassign:
              </label>
              <select id="corr-person-select" onChange={(event) => { handleDutyCorrPersonChange() }} className="w-full bg-slate-950 border border-amber-500/60 rounded-xl p-2.5 text-xs text-white focus:outline-none focus:border-amber-400 font-bold">
                {/* Dynamically populated with all personnel */}
              </select>
            </div>
            {/* Selected Officer Live Overview Banner */}
            <div id="corr-officer-banner" className="p-3 bg-slate-950 rounded-xl border border-slate-800 space-y-1">
              <div className="flex items-center justify-between">
                <span id="corr-badge-cadre" className="px-2 py-0.5 rounded text-[10px] font-black bg-indigo-600 text-white">
                  POLICE CONSTABLE
                </span>
                <span id="corr-live-status-pill" className="text-[10px] font-bold text-amber-400">
                  AT STATION
                </span>
              </div>
              <div id="corr-name-display" className="font-bold text-white text-sm">
                --
              </div>
              <div id="corr-current-duty" className="text-slate-400 text-[11px]">
                Current: PS-0001 • Polling Station Duty
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block font-bold text-slate-200 mb-1 flex items-center justify-between">
                  <span>
                    Reassign Polling Booth Code:
                  </span>
                  <span className="text-[10px] text-amber-400 font-normal">
                    Blank for Reserve
                  </span>
                </label>
                <input type="text" id="corr-booth-code" placeholder="e.g. PS-0004 or STANDBY_RESERVE" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white font-mono placeholder-slate-500 focus:outline-none focus:border-amber-500 font-bold" />
              </div>
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Reassign Duty Wing / Formation:
                </label>
                <select id="corr-duty-wing" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white focus:outline-none focus:border-amber-500">
                  <option value="POLLING_STATION">
                    🏛️ Polling Station Sentry
                  </option>
                  <option value="ROUTE_MOBILE">
                    🚓 Route Mobile Patrol
                  </option>
                  <option value="CHECK_POST">
                    🚧 Border / Arterial Check Post
                  </option>
                  <option value="STRIKING_FORCE">
                    ⚡ Striking Force (QRT)
                  </option>
                  <option value="FLYING_SQUAD">
                    🦅 Flying Squad (FST)
                  </option>
                  <option value="STRONG_ROOM">
                    🏛️🔐 Strong Room EVM Guard
                  </option>
                  <option value="SHADOW_PARTY">
                    🕵️ Shadow Party Surveillance
                  </option>
                  <option value="GAS_PARTY">
                    🦺💨 Gas Party (Anti-Riot)
                  </option>
                  <option value="DRONE_OPERATOR">
                    🛸 Drone Surveillance Operator
                  </option>
                  <option value="COORDINATION_TEAM">
                    🤝 Coordination Liaison Team
                  </option>
                  <option value="RESERVE_FORCE">
                    🛡️ Standby Reserve Force
                  </option>
                </select>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Duty Allocation Category:
                </label>
                <select id="corr-allotment-select" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white focus:outline-none focus:border-amber-500">
                  <option value="ALLOTTED">
                    ✅ Allotted Duty (Deployed at Booth / Unit)
                  </option>
                  <option value="NOT_ALLOTTED">
                    🛡️ Not Allotted (Standby Reserve Pool)
                  </option>
                </select>
              </div>
              <div>
                <label className="block font-bold text-slate-200 mb-1">
                  Correct Attendance / Moving Status:
                </label>
                <select id="corr-status-select" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white focus:outline-none focus:border-amber-500">
                  <option value="AT_STATION">
                    🟢 On-Site At Station (≤75m)
                  </option>
                  <option value="TRAVELLING">
                    🚗 Moving / Travelling on Duty
                  </option>
                  <option value="AWAY">
                    ⚠️ Away from Geofenced Post
                  </option>
                  <option value="STANDBY_RESERVE">
                    🛡️ Standby in Reserve Platoon
                  </option>
                  <option value="DUTY_NOT_ATTENDED">
                    🔴 Absent / Duty Not Attended
                  </option>
                </select>
              </div>
            </div>
            <div className="flex justify-end gap-2 pt-2 border-t border-slate-800">
              <button type="button" onClick={(event) => { closeDutyCorrectionModal() }} className="px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-xl text-xs font-semibold text-slate-300">
                Cancel
              </button>
              <button type="submit" className="px-5 py-2 bg-gradient-to-r from-amber-600 to-yellow-600 hover:from-amber-500 hover:to-yellow-500 text-slate-950 rounded-xl text-xs font-bold shadow-lg flex items-center gap-1.5">
                <span>
                  💾
                </span>
                {' '}Save & Apply Duty Correction
              </button>
            </div>
          </form>
        </div>
      </div>
      <div id="admin-sos-list-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-4xl p-5 sm:p-7 shadow-2xl text-slate-200 flex flex-col max-h-[92vh]">
          {/* Modal Header */}
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-3">
            <div className="flex items-center gap-3">
              <div id="admin-modal-main-icon" className="w-12 h-12 rounded-2xl bg-gradient-to-tr from-red-600 to-rose-700 flex items-center justify-center text-white shadow-xl text-2xl font-black shrink-0 animate-pulse">
                🚨
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-black text-white flex items-center gap-2">
                  <span id="admin-modal-main-title">
                    Emergency SOS & Duty Attendance Incident Command
                  </span>
                  <span id="admin-modal-status-badge" className="px-2 py-0.5 rounded text-[10px] font-bold bg-red-500/20 text-red-400 border border-red-500/30">
                    LIVE REAL-TIME
                  </span>
                </h3>
                <p className="text-xs text-slate-400">
                  Live distress alerts triggered by police personnel in staff app & duty non-attendance list
                </p>
              </div>
            </div>
            <button type="button" onClick={(event) => { closeAdminEmergencySosModal() }} className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white flex items-center justify-center text-2xl font-bold transition">
              ×
            </button>
          </div>
          {/* Segmented Tabs: Emergency SOS vs Not Attended */}
          <div className="grid grid-cols-2 gap-2 bg-slate-950 p-1.5 rounded-2xl border border-slate-800 text-xs font-bold mb-3">
            <button type="button" id="admin-modal-tab-sos" onClick={(event) => { switchAdminSosTab('SOS') }} className="py-2.5 px-3 rounded-xl transition flex items-center justify-center gap-2 bg-red-600 text-white shadow-lg">
              <span className="text-base">
                🚨
              </span>
              <span>
                Active Emergency SOS Incidents
              </span>
              <span id="modal-tab-sos-count" className="px-2 py-0.2 rounded-full bg-black/30 font-mono text-xs">
                --
              </span>
            </button>
            <button type="button" id="admin-modal-tab-absent" onClick={(event) => { switchAdminSosTab('NON_ATTENDED') }} className="py-2.5 px-3 rounded-xl transition flex items-center justify-center gap-2 bg-slate-800 text-slate-300 hover:text-white">
              <span className="text-base">
                ✕
              </span>
              <span>
                Duty Not Attended Officers
              </span>
              <span id="modal-tab-absent-count" className="px-2 py-0.2 rounded-full bg-slate-700 font-mono text-xs">
                --
              </span>
            </button>
          </div>
          {/* Quick Search & Actions Filter Bar */}
          <div className="flex items-center justify-between gap-3 pb-2 mb-2 border-b border-slate-800 text-xs">
            <div className="relative flex-1">
              <input type="text" id="admin-modal-search-input" placeholder="Search officer name, badge, phone, booth, police station..." className="w-full bg-slate-950 border border-slate-700 rounded-xl pl-8 pr-3 py-1.5 text-xs text-white placeholder-slate-400 focus:outline-none focus:border-red-500" onInput={(event) => { renderAdminModalActiveList() }} />
              <span className="absolute left-2.5 top-2 text-slate-400">
                🔍
              </span>
            </div>
            <div className="flex items-center gap-1.5 shrink-0">
              <a href="/emergency-sos" className="px-3 py-1.5 bg-slate-800 hover:bg-slate-700 text-slate-200 hover:text-white border border-slate-700 rounded-xl font-bold flex items-center gap-1.5 transition">
                <span>
                  📋
                </span>
                {' '}Full Incident Grid →
              </a>
            </div>
          </div>
          {/* Scrollable List Body */}
          <div id="admin-modal-list-body" className="flex-1 overflow-y-auto space-y-3 pr-1 text-xs min-h-[300px]">
            {/* Rendered dynamically by renderAdminModalActiveList() */}
          </div>
          {/* Footer */}
          <div className="pt-3 border-t border-slate-800 mt-3 flex items-center justify-between text-xs">
            <div className="flex items-center gap-2 text-slate-400 text-[11px]">
              <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
              <span>
                SyncEngine Active: Auto-refreshes immediately when staff pings SOS or attendance
              </span>
            </div>
            <button type="button" onClick={(event) => { closeAdminEmergencySosModal() }} className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white rounded-xl font-bold transition">
              Close
            </button>
          </div>
        </div>
      </div>
      {/* TOAST CONTAINER */}
      <div id="toast-container"></div>

      {/* UPLOAD ROSTER MODAL */}
      <UploadRoster
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        defaultTab="OFFICERS"
        tabs={[
          "OFFICERS",
          "SUBDIVISIONS",
          "CIRCLES",
          "STATIONS",
          "BOOTHS",
        ]}
        onUpload={handleRosterUpload}
        onSuccess={() => {
          console.log("Refresh officer list");
        }}
      />
    </div>
  );
}
